import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, ViewChild, TemplateRef, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SnackbarService } from '../../_service/message-service';
import { Subject } from 'rxjs';
import { LoaderService } from 'src/app/loader.service';
import { AuthenticationService, UserService } from 'src/app/_services';
import { VendorService } from 'src/app/_services/vendor.services';
import { GeneralDialogComponent } from 'src/app/shared/components/general-dialog/general-dialog.component';
import { TableBtn, TableColumn } from 'src/app/shared/interfaces';
import { Subscription } from 'rxjs';
import { ExportCSVService } from 'src/app/_services/export-csv.service';
import { MatDialog } from '@angular/material/dialog';
import { map } from 'rxjs/operators';
import { ConfirmDialogComponent } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { UserInfoService } from 'src/app/_services/userInfo.service';
import { Role } from 'src/app/util/enums/role.enum';
import { Permission } from 'src/app/util/enums/permission.enum';
import { NotificationService } from 'src/app/_services/notification.service.v2';
declare var $: any;
export interface updateList {
  id: number;
  description: string;
  title: string;
  date: string;
  time: string;
  attachment: string;
  enable: string;
  orgId: number;
  no: number;
  url: string;
  alertType: string;
}
@Component({
  selector: 'telio-information',
  templateUrl: './information.component.html',
  styleUrls: ['./information.component.scss']
})
export class InformationComponent implements OnInit, OnDestroy {
  @ViewChild('imagepopup', { static: false }) imagepopup: TemplateRef<any>;
  @ViewChild('updateAlert', { static: false }) updateAlert: TemplateRef<any>;
  dtTrigger = new Subject();
  actionFeatureFlag = false;

  updateForm: FormGroup;
  updateList: updateList[];
  data: updateList[];
  userDetails: any = {};
  vendorArray = [];
  connectors = [];
  showSubmenu: boolean = false;
  id: string = "";
  adminrole: any;
  imageURL: any;
  currentuser: any = {};
  columns: TableColumn[];
  buttons: TableBtn[];
  filterPlaceholder: string = '';
  actionHeader: string = '';
  subscription: Subscription = new Subscription;
  initialData: any;
  actionFeatureLabel: string = ' ';
  pageList = {
    currentPage: 0,
    pageSize: 10
  };
  currentPage = 0;
  totalDataCount = 0;
  sortColumn = 'id';
  sortDirection = 'desc';
  selectedFile = null;
  url;
  rownum = 0;
  orderedList = [];
  vendorCreatedDate = new Date();
  vendorCreatedTime;
  updatedList = [];
  createDate;
  totalItems;
  totalFilteredItems;
  deleteId: any;
  selectedFilePreview = null;
  senderList: string[] = ['CPO', 'EV USER'];
  selectedId: number;
  infoTitle = 'information.addUpdate';

  constructor(private userservice: UserService,
    private vendorservice: VendorService,
    private userInfoService: UserInfoService,
    public translate: TranslateService,
    private activateRoute: ActivatedRoute,
    private notificationService:NotificationService,
    public loaderService: LoaderService,
    readonly exportCSVService: ExportCSVService, private authenticationService: AuthenticationService,
    private toastr: SnackbarService, public dialog: MatDialog,
    @Inject(DOCUMENT) private _document: HTMLDocument,
    readonly routed: ActivatedRoute,
    readonly _formBuilder: FormBuilder) {

    this.getRole(this.pageList, '')

    this.columns = [
      { columnDef: 'id', header: 'information.id', cell: (element: updateList) => `${element.orgId}`, sortingDisabled: false, width: '60px', isLink: this.userInfoService.filterPermission(+this.activateRoute.snapshot.paramMap.get('routeID'), Permission.READ) },
      { columnDef: 'title', header: 'information.formTitle', cell: (element: updateList) => `${element.title}`, sortingDisabled: false, width: '250px' },
      { columnDef: 'description', header: 'information.description', cell: (element: updateList) => `${element.description}`, sortingDisabled: false, width: '250px' },
      { columnDef: 'alertType', header: 'information.alertType', cell: (element: updateList) => `${element.alertType}`, sortingDisabled: false, width: '100px' },
      { columnDef: 'timestamp', header: 'information.date', cell: (element: updateList) => `${element.date}`, sortingDisabled: false, width: '100px' },
      { columnDef: 'time', header: 'information.time', cell: (element: updateList) => `${element.time}`, sortingDisabled: true, width: '100px' }
    ];
    this.buttons = [
      { styleClass: 'submit', icon: 'edit', payload: (element: updateList) => `${element.id}`, action: 'edit', tooltip: 'faq.edit', enable: this.checkPermission(+this.routed.snapshot.paramMap.get('routeID'), Permission.UPDATE) },
      { styleClass: 'submit', icon: 'delete', payload: (element: updateList) => `${element.id}`, action: 'delete', tooltip: 'faq.delete', enable: this.checkPermission(+this.routed.snapshot.paramMap.get('routeID'), Permission.DELETE) },
    ];
    this.actionHeader = 'information.actions';
    this.filterPlaceholder = 'generalTable.filterPlaceholder';
    this.actionFeatureLabel = 'information.addUpdate';
  }

  ngOnInit(): void {
    this.actionFeatureFlag = this.userInfoService.isAdminGroup() && this.userInfoService.filterPermission(+this.routed.snapshot.params['routeID'], Permission.CREATE);
    this.updateNotifications();
    this.authenticationService.setEmail(this.userDetails.email);
    this.vendorCreatedDate = this.userDetails.createdDate
    var cDate = new Date(this.vendorCreatedDate).toISOString().replace(/.\d+Z$/g, "Z")
    this.createDate = new Date(cDate).toISOString().replace('T', ' ').replace('.000Z', "")
    this.currentuser = this.userInfoService.userDetails;
    this.vendorArray.push(this.id)
    this.vendorCreatedTime = new Date(this.vendorCreatedDate).getTime()
    this.updateForm = new FormGroup({
      description: new FormControl(),
      formTitle: new FormControl(),
      alertType: new FormControl()
    })
  }

  checkPermission(id: number, permission: string): boolean {
    return this.userInfoService.filterPermission(id, permission)
  }

  viewFile(url): void {
    if (url == "NA") {
      this.toastr.error(this.translate.instant('information.noImage'));
      return;
    }
    let dialogRef = this.dialog.open(this.imagepopup, {
      width: 'auto',
      height: '80vh',
    }).afterClosed()
    this.imageURL = url;

  }

  getRole(value: any, searchFilter?: string) {
    this.userDetails = this.userInfoService.userDetails;
    this.vendorCreatedDate = this.userDetails.createdDate
    let cDate = new Date(this.vendorCreatedDate).toISOString().replace(/.\d+Z$/g, "Z")
    this.createDate = new Date(cDate).toISOString().replace('T', ' ').replace('.000Z', "")
    this.userInfoService.isAdminGroup() ? this.getAllNotifications(value, searchFilter) : this.getVendorNotifications(this.createDate, value, searchFilter);
  }

  getAllNotifications(value: any, searchFilter: string = '') {
    this.subscription.add(this.userservice.getAllUpdates(value.currentPage + 1, value.pageSize, this.sortColumn, this.sortDirection, searchFilter)
      .pipe(map(events => {
        this.data = events.data;
        this.setMobileUserMap(this.data);
        this.totalDataCount = events.totalItems;
      })).subscribe());
  }

  setMobileUserMap(events) {
    if (!!events && events.length > 0) {
      events.map((event: any, i: number) => {
        let empty = 'NA';
        event.no = i;
        event.orgId = event.id;
        event.title = !event.title ? empty : this.userInfoService.capitalizeFirstLetter(event.title);
        event.url = !event.url ? empty : event.url;
        event.alertType = !event.alertType ? empty : event.alertType;
        event.description = !event.description ? empty : this.userInfoService.capitalizeFirstLetter(event.description);
        event.date = !event.timestamp ? empty : this.authenticationService.convertToLocalTime(event.timestamp, this.userInfoService.userDetails.prefCountry).split(' ')[0];
        event.time = !event.timestamp ? empty : this.authenticationService.convert24HrTo12Hr(this.authenticationService.convertToLocalTime(event.timestamp, this.userInfoService.userDetails.prefCountry)).slice(11, 19);
      })
    }
  }

  actionClick() {
    this.getRole(this.pageList, '')
  }

  buttonClick(event) {
    if (event[0] == 'delete') {
      this.deleteInfobyId(event[1])
    } else if (event[0] == 'edit') {
      this.selectedId = null;
      this.updateInfo(event[1]);
    }
  }

  updateInfo(id): void {
    let data = this.data.filter(x => x.id == id);
    if (data.length > 0) {
      this.updateForm.get('formTitle').setValue(this.userInfoService.capitalizeFirstLetter(data[0].title));
      this.updateForm.get('description').setValue(this.userInfoService.capitalizeFirstLetter(data[0].description));
      this.updateForm.get('alertType').setValue(data[0].alertType);
      this.selectedFilePreview = data[0].url == 'NA' ? null : data[0].url;
      this.infoTitle = 'information.infoTip';
      this.selectedId = id;
      let dialogRef = this.dialog.open(this.updateAlert, {
        width: '72vw',
        height: '92vh'
      }).afterOpened().subscribe();
    }
  }

  getVendorNotifications(date, value: any, searchFilter: string = '') {
    this.subscription.add(this.userservice.getVendorUpdates(date, value.currentPage + 1, value.pageSize, this.sortColumn, this.sortDirection, searchFilter)
      .pipe(map(events => {
        this.data = events.data
        this.setMobileUserMap(this.data);
        this.totalDataCount = events.totalItems;
      })).subscribe());
  }

  applyFilter(filteredData: string) {
    this.getRole(this.pageList, filteredData)
  }

  updateNotifications() {
    let type = "Info"
    this.notificationService.updateInfonotification(this.userDetails.userId, type).subscribe();
  }

  onFileSelected(event) {
    let x = event.target.files[0];
    this.selectedFile = x;
    var fileName = x.name
    var imageSize = x.size
    var idxDot = fileName.lastIndexOf(".") + 1;
    var extFile = fileName.substr(idxDot, fileName.length).toLowerCase();
    if (imageSize > 1048576) {
      this.toastr.error(this.translate.instant('createStation.uploadimgSizeError'))
      event.target.value = null;
      return false
    }
    if (extFile == "jpg" || extFile == "jpeg" || extFile == "png") {
      let reader = new FileReader();
      let url;
      reader.onload = () => {
        url = reader.result;
        this.selectedFilePreview = url;
      };
      reader.readAsDataURL(x);
    } else {
      this.toastr.error(this.translate.instant('createStation.imgTypeError'));
      event.target.value = null;
      return false
    }
  }

  submitInfo() {
    const formdata = new FormData();
    this.selectedId ? formdata.append('id', this.selectedId.toString()) : '';
    formdata.append('description', this.userInfoService.capitalizeFirstLetter(this.updateForm.value.description));
    formdata.append('title', this.userInfoService.capitalizeFirstLetter(this.updateForm.value.formTitle));
    formdata.append('alertType', this.updateForm.value.alertType);
    !!this.selectedFile && formdata.append('file', this.selectedFile);
    this.userservice.postUpdate(formdata).subscribe((resp: any) => {
      if (resp != null) {
        this.selectedId = null;
        this.toastr.success(resp);
        this.getRole(this.pageList, '');
        this.dialog.closeAll();
      }
      else {
        this.toastr.error(resp)
      }
    }, (error: any) => {
      this.toastr.error(this.translate.instant('responseFailed'));
    });
  }

  deleteInfobyId(id) {
    this.deleteId = id;
    this.deleteFeature(id);
  }

  deleteInfo(id) {
    this.userservice.deleteUpdate(id).subscribe((resp: any) => {
      if (resp != null) {
        this.toastr.success(resp)
        this.getRole(this.pageList, '')
      }
      else {
        this.toastr.error(resp)
      }
    }, (error: any) => {
      this.toastr.error(this.translate.instant('responseFailed'));
    });
  }

  actionCSV() {
    const options = {
      filename: this.translate.instant('information.InformationfileName'),
      showTitle: false,
      title: this.translate.instant('information.InformationfileName'),
      useKeysAsHeaders: true,
    }
    if (this.userInfoService.isAdminGroup()) {
      this.subscription.add(this.userservice.getAllUpdates(1, this.totalDataCount, this.sortColumn, 'asc', '').subscribe(
        (resp: any) => {
          let csvData = resp.data
          this.setMobileUserMap(csvData);
          const filteredData = csvData.map(event => {
            const { timestamp, ...rest } = event; 
            return rest;
          });
          this.exportCSVService.exportCSV(options, filteredData);
        }));
    } else {
      this.subscription.add(this.userservice.getVendorUpdates(this.createDate, 1, this.totalDataCount, this.sortColumn, 'asc', '').subscribe(
        (resp: any) => {
          let csvData = resp.data
          this.setMobileUserMap(csvData);
          const filteredData = csvData.map(event => {
            const { timestamp, ...rest } = event; 
            return rest;
          });
          this.exportCSVService.exportCSV(options, filteredData);
        }));
    }
  }

  actionFeature(event) {
    this.infoTitle = 'information.addUpdate';
    let dialogRef = this.dialog.open(this.updateAlert, {
      width: '72vw',
      height: '92vh',
    }).afterClosed()
    this.updateForm.reset();
    this.selectedFilePreview = null;
  }

  loadData(value: any) {
    let val = {
      currentPage: value.currentPage,
      pageSize: value.pageSize
    }
    this.pageList.pageSize = value.pageSize;
    this.getRole(val, '')
  }

  sortClick(event: any) {
    this.sortColumn = event.active;
    this.sortDirection = event.direction;
    this.getRole(this.pageList, '')
  }

  linkClick(event) {
    if (event.column.columnDef == "id") {
      this.viewFile(event.row.url);
    }
  }

  deleteFeature(id): void {
    let dialogRef = this.dialog.open(GeneralDialogComponent, {
      width: '50vw',
      height: '200px',
      data: { component: ConfirmDialogComponent,  message: this.translate.instant('information.deactivateMessage'), button: this.translate.instant('faq.confirmButton'), title: this.translate.instant('createStation.confiration'), otherbtn: this.translate.instant('faq.confirmNo') }
    }).afterClosed().subscribe(res => {
      if (res && res == 'Yes') {
        this.deleteInfo(id);
      }
    });
  }

  checkBoxStatus(): boolean {
    return this.updateForm.get('alertType').value && !(this.updateForm.get('alertType').value == 'NA');
  }

  ngOnDestroy() {
    this.subscription && this.subscription.unsubscribe();
  }
}
